import type { CastItem } from "@/types/aggregate-items";
import { imageUrl } from "@/utils/image";
export interface Input {
  item: CastItem;
}
$ const { item } = input;

<a href=item.url class="cast-discover-item-card" on-click("handleItemClick")>
  <evo-masonry-image
    class="cast-discover-item-card__image"
    src=imageUrl(item.image, { imageWidth: "1600", quality: "q-40" })
    width=(item.image.imageWidth)
    height=(item.image.imageHeight)
  />
  <div class="cast-discover-item-card__influencer">
    <ebay-avatar
      class="cast-discover-item-card__influencer-avatar"
      a11yText=`${item.influencer.name}'s avatar`
      username=(item.influencer.name)
      size="32"
    >
      <if(item.influencer.avatar)>
        <@img src=imageUrl(item.influencer.avatar, { imageSize: "100" })/>
      </if>
    </ebay-avatar>
    <span class="cast-discover-item-card__influencer-name">
      ${item.influencer.name}
    </span>
  </div>
  <div class="cast-discover-item-card__price">
    ${item.displayPrice}
  </div>
</a>
